
import React, { Component } from "react";
import {Row,Col} from "react-bootstrap";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/themes/light.css';
import 'tippy.js/animations/shift-toward.css';
import 'tippy.js/animations/shift-toward-subtle.css';
import 'tippy.js/animations/shift-toward-extreme.css';
import { LineHeightOutlined } from "@ant-design/icons";
export const Card = (props) => {
      const customStyles = {
        marginTop:'0px',
        marginBottom:'10%', 
        padding: '15px 15px 0', 
        fontWeight:500
      }

      const genericStyle = {
        fontWeight:'700',
        fontSize:'28px',
        padding: '15px 15px 0'
      }
  
    
    return (
      <div 
      className={"card" + (props.filter ? " card-filter" : "") + (props.plain ? " card-plain" : "")} style={{boxShadow:props.shadowbox ? props.shadowbox : ''}}>
        <div>
           {typeof props.condition === "object" ? 
           <Row>
              <Col md="6" className = "mb-3">
              <h5 style={{marginInlineStart:"1em"}}>{props.condition.props.children[0]}
                <a href='#!' className='font-weight-bold' style={{color:'#D54C2F'}}>
                  <strong> {props.condition.props.children[1].props.children[1]} </strong>
                </a>
              </h5>
              </Col>
              </Row> : ""}
        {/* // <h4>{props.condition.props.children[0]}</h4> : "" */}
          
        </div>
        {props.filter !== true ? 
        <div>
        <Row>
        <Col md="6" className="mb-6">
          <h4 style={props.id === 'chartHours' ? customStyles : genericStyle}>{props.title}
          {props.elements ?
                  <div style={{marginTop:'-20px'}}>
                    <Tippy offset={[60, 20]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                      <h5 style={{height:'34px', width:'15rem', fontSize:"13px"}}>Inventory will be loaded based on the selected locations only</h5>
                    </div>}>
                      {props.infoIcon}
                    </Tippy>
                  </div> : 
            <a href='#!' className='font-weight-bold' style={{color:'rgba(0, 0, 0, 0.85)'}}>
            <strong> {props.title2}  </strong>
            </a>}
          </h4>
        </Col>
              {
                (props.timeStamp) && (
                  <>
                    <Col md="2" className="mb-2"></Col>
                    <Col md="5" className="mb-5 dispatch-timestamp">
                      {props.timeStamp && <><span className="last-updated" >Last updated: &nbsp;</span> <span className="timestamp" >{props.timeStamp}</span></>}
                    </Col>
                  </>
                )
              }
        {props.id === 'chartHours' &&
        <>
        <Col md="5" className="mb-5">
        </Col>
        <Col md="2" className="mb-2">
          <h4 className="header">{props.drop}
          </h4>
        </Col>
        </>}
       {props.hCenter == "Available Serial Number : " &&
        <Row>
                  <Col md="3" className="mb-3">
        <h4 className={"text-center"} style={{ marginTop: "55px", marginInlineStart: "-12em" }}>{`${props.hCenter}`}
            <a href='#!' className='font-weight-bold' style={{ color: '#D54C2F' }}>
            <strong> {props.iotQty}  </strong>
            </a>
          </h4>
          </Col>
        </Row>
              }
        {props.condition && 
        <Row>
          <Col md="3" className="mb-3">
          <h4 style={{ marginTop: "-9px", marginInlineStart: "-67rem" }}>{props.condition}
          </h4>
          </Col>
        </Row>}
          </Row>
          {props?.button && 
          <Col md="12" className="mb-12">
          <div style={{float: 'right'}}>{props.button}
          </div>
          </Col>}
          </div> : ""}
        <div 
          className={
            "content"  + 
            
            (props.ctAllIcons ? " all-icons" : "") +
            (props.ctTableFullWidth ? " table-full-width" : "") +
            (props.ctTableResponsive ? " table-responsive" : "") +
            (props.ctTableUpgrade ? " table-upgrade" : "")
          }
        >
          {props.content}

         {props.footer && <div className="footer" >
            {props.legend}
            {props.stats != null ? <hr /> : ""}
            <div className="stats">
              <i className={`${props.statsIcon} statsIcon`} /> {props.stats}
            </div>
          </div>}
        </div>
      </div>
    );
  }

export default Card;
